require('./blocks/news/news');
require('./blocks/video-item.less');
require('./blocks/mini-slider/mini-slider');
require('./blocks/rating-stars/rating-stars');
require('./blocks/workshop.less');
require('./blocks/workshop-item.less');
require('./blocks/soc-area.less');
require('./blocks/review.less');
require('./blocks/reviews/reviews');
require('./blocks/impromptu/impromptu-comment');
require('./blocks/seminar.less');

require('./blocks/seminar-detail/seminar-detail.js');
require('./plugins/jquery.loader/require.js');
require('./blocks/web-form/web-form.js');
require('./blocks/seminars-video/seminars-video');



// WEBPACK FOOTER //
// ./workshop.js